import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Feeds from "@/pages/Feeds";
import News from "@/pages/News";
import Errors from "@/pages/Errors";
import Tester from "@/pages/Tester";
import Account from "@/pages/Account";
import Admins from "@/pages/Admins";
import AcceptInvite from "@/pages/AcceptInvite";
import Integrations from "@/pages/Integrations";
import Notifications from "@/pages/Notifications";
import Layout from "@/components/Layout";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#050505] text-zinc-400 font-mono text-sm">
        <span className="blink">INITIALIZING_SYSTEM…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function SuperAdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App bg-[#050505] text-zinc-100">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/feeds" element={<Protected><Feeds /></Protected>} />
            <Route path="/news" element={<Protected><News /></Protected>} />
            <Route path="/errors" element={<Protected><Errors /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/tester" element={<Protected><Tester /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/admins" element={<SuperAdminOnly><Admins /></SuperAdminOnly>} />
            <Route path="/integrations" element={<SuperAdminOnly><Integrations /></SuperAdminOnly>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
